
require(['text!locale/supported.json', 'text!locale/en.json', 'text!locale/fr.json']);
define("langs", function(){});
